import WalletSigningController from "../lib/wallet_signing_controller"
import { COPY } from "../lib/wallet_connector_controller"
import { workStatus, setBusy } from "../lib/work_status"

// The one-tap invest page (F3, R8): one button walks every pending basket,
// each still its own transaction the wallet confirms.
export default class extends WalletSigningController {
  get idleStatus() {
    return this.privyProvider ? "Ready when you are" : "Connect your wallet to confirm"
  }

  // Run the pending purchases in order: build each fresh, let the wallet send
  // it, tell the server what came back. A rejection stops the run and leaves
  // the server's records exactly as they were, so the same button just picks
  // up where it left off. When the last purchase resolves, the reload lands on
  // the portfolio (the server redirects a finished month there).
  async confirmAll(event) {
    const button = event.currentTarget
    setBusy(button, true)

    try {
      if (!(await this.ensureConnected())) return

      for (const row of this.pendingRows()) {
        const { bag, buildUrl, confirmUrl } = row.dataset
        await this.confirmOne(bag, buildUrl, confirmUrl)
        delete row.dataset.pendingLeg
      }
      window.location.assign(window.location.pathname)
    } catch (error) {
      this.log("purchase run stopped", error)
    } finally {
      setBusy(button, false)
    }
  }

  async confirmOne(bag, buildUrl, confirmUrl) {
    try {
      this.setStatus(bag, "Setting this up…", "working")
      const { transaction } = await this.postJSON(buildUrl, {})

      this.setStatus(bag, this.walletPromptCopy, this.walletPromptState)
      const signature = await this.signAndSend(transaction)

      this.setStatus(bag, "Confirming…", "working")
      await this.postJSON(confirmUrl, { signature })

      this.setStatus(bag, "Done", "done")
    } catch (error) {
      this.setStatus(bag, error.userMessage || COPY.rejected, "error")
      // A basket the server decided to skip doesn't stop the others.
      if (error.serverStatus === "skipped") return
      throw error
    }
  }

  pendingRows() {
    return Array.from(this.element.querySelectorAll("[data-pending-leg]"))
  }

  // Each basket's own line under its row, with the same marks as the
  // status line (lib/work_status.js).
  setStatus(bag, text, state) {
    workStatus(document.getElementById(`status-${bag}`), text, state)
  }
}
